import Swiper from 'swiper';
import { Autoplay, Controller, EffectFade, Keyboard, Navigation, Pagination, Thumbs, Zoom } from 'swiper/modules';
function initSwiper(selector) {
    if (!selector) {
        return false;
    }
    return new Swiper(selector, {
        spaceBetween: 24,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        modules: [Navigation, EffectFade],
        navigation: {
            nextEl: `${selector} .swiper-button-next`,
            prevEl: `${selector} .swiper-button-prev`,
        },
    });
}
function initSwiperHeroBanner() {
    const selector = '.hero-banner-swiper';
    const swiper = new Swiper(selector, {
        modules: [Pagination, Navigation, Autoplay],
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: `${selector} .swiper-pagination`,
            clickable: true,
        },
        navigation: {
            nextEl: `${selector} .swiper-button-next`,
            prevEl: `${selector} .swiper-button-prev`,
        },
    });
    const header = document.getElementById('site-header');
    function onSlideChangeTransitionEnd(slider) {
        const activeSlide = slider.slides[slider.activeIndex];
        const wrapper = slider.el;
        if (!activeSlide || !wrapper)
            return;
        const slideColor = activeSlide.getAttribute('data-hero-theme');
        if (slideColor) {
            header === null || header === void 0 ? void 0 : header.setAttribute('data-hero-theme', slideColor);
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.setAttribute('data-hero-theme', slideColor);
        }
    }
    onSlideChangeTransitionEnd(swiper);
    swiper.on('slideChangeTransitionEnd', onSlideChangeTransitionEnd);
    return swiper;
}
function initMarqueeLineSwiper() {
    var _a;
    const marqueeContent = document.querySelector('.marquee-content');
    if (marqueeContent) {
        for (let i = 0; i < 3; i++) {
            const clone = marqueeContent.cloneNode(true);
            (_a = marqueeContent.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(clone);
        }
        marqueeContent === null || marqueeContent === void 0 ? void 0 : marqueeContent.remove();
    }
    const marqueeLine = document.querySelector('.marquee-line');
    marqueeLine === null || marqueeLine === void 0 ? void 0 : marqueeLine.classList.add('play');
}
function initOftenChooseSwiper() {
    const selector = '.often-choose-swiper';
    return new Swiper(selector, {
        modules: [Navigation, Autoplay, Pagination],
        spaceBetween: 12,
        allowTouchMove: true,
        slidesPerView: 'auto',
        autoplay: {
            delay: 21000,
            disableOnInteraction: true,
        },
        pagination: {
            el: `${selector} .swiper-pagination`,
            clickable: true,
        },
        navigation: {
            nextEl: `${selector} .swiper-button-next`,
            prevEl: `${selector} .swiper-button-prev`,
        },
        breakpoints: {
            1440: {
                spaceBetween: 16,
            },
        },
    });
}
function initCrossSellsSwiper() {
    const selector = '.suggestion-items';
    return new Swiper(selector, {
        modules: [],
        spaceBetween: 12,
        slidesPerView: 'auto',
        slidesOffsetBefore: 15,
    });
}
function initCartPromoSwiper() {
    const selector = '.cart-promo-card';
    return new Swiper(selector, {
        modules: [Pagination],
        loop: true,
        watchOverflow: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: `${selector} .swiper-pagination`,
            clickable: true,
        },
        spaceBetween: 24,
        slidesPerView: 'auto',
        on: {
            slideChange() {
                this.pagination.render();
                this.pagination.update();
            },
        },
    });
}
function initInstagramReviewSwiper() {
    const selector = '.instagram-review-swiper';
    return new Swiper(selector, {
        modules: [Pagination, Navigation],
        speed: 700,
        navigation: {
            nextEl: `${selector} .swiper-button-next`,
            prevEl: `${selector} .swiper-button-prev`,
        },
        breakpoints: {
            0: {
                centeredSlides: false,
                slidesPerView: 1.6,
                spaceBetween: 12,
                slidesOffsetBefore: 16,
            },
            576: {
                slidesPerView: 2.5,
                spaceBetween: 12,
                slidesOffsetBefore: 0,
            },
            768: {
                slidesPerView: 2.7,
                spaceBetween: 24,
                slidesOffsetBefore: 0,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1210: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1920: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });
}
function initCertificatesSwiper() {
    const selector = '.certificates-swiper';
    return new Swiper(selector, {
        modules: [Pagination, Navigation],
        speed: 700,
        navigation: {
            nextEl: `${selector} .swiper-button-next`,
            prevEl: `${selector} .swiper-button-prev`,
        },
        breakpoints: {
            0: {
                centeredSlides: false,
                slidesPerView: 1.6,
                spaceBetween: 12,
                slidesOffsetBefore: 16,
            },
            576: {
                slidesPerView: 2.5,
                spaceBetween: 12,
                slidesOffsetBefore: 0,
            },
            768: {
                slidesPerView: 2.7,
                spaceBetween: 24,
                slidesOffsetBefore: 0,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1210: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1920: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    });
}
function initCatalogueBanner() {
    const selector = '.catalogue-banner-slider';
    const swiper = new Swiper(selector, {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        autoplay: {
            delay: 30000,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: `${selector} .swiper-pagination`,
            clickable: true,
        },
    });
    return swiper;
}
function initCheckoutSlider() {
    const selector = '.step-client-data-slider';
    const swiper = new Swiper(selector, {
        modules: [Autoplay, Pagination],
        spaceBetween: 12,
        slidesPerView: 1,
        loop: false,
        autoplay: {
            delay: 30000,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: `${selector} .swiper-pagination`,
            clickable: true,
        },
    });
    return swiper;
}
function initFsSlider(selector, initialSwiper) {
    const swiper = new Swiper(`${selector} .fs-slider`, Object.assign({ modules: [Autoplay, Pagination, Navigation, Controller, Zoom, Keyboard], zoom: true, slidesPerView: 1, centeredSlides: true, pagination: {
            el: `${selector} .fs-slider .swiper-pagination`,
            clickable: false,
        }, navigation: {
            nextEl: `${selector} .fs-slider .swiper-button-next`,
            prevEl: `${selector} .fs-slider .swiper-button-prev`,
        }, keyboard: {
            enabled: true,
        } }, (initialSwiper
        ? {
            controller: { control: initialSwiper },
        }
        : {
            autoplay: {
                delay: 30000,
                pauseOnMouseEnter: true,
            },
        })));
    return swiper;
}
function initProductSliderThumb() {
    const selector = '.product-info-slider';
    const swiper = new Swiper(selector, {
        modules: [Navigation],
        spaceBetween: 8,
        slidesPerView: 'auto',
        direction: 'vertical',
        freeMode: false,
        watchSlidesProgress: true,
        centeredSlides: false,
        slideToClickedSlide: true,
        navigation: {
            nextEl: `${selector} .swiper-button-next`,
            prevEl: `${selector} .swiper-button-prev`,
        },
    });
    return swiper;
}
function initProductSlider() {
    var _a;
    const thumbs = initProductSliderThumb();
    const selector = '.product-info-main-slider';
    const swiper = new Swiper(selector, {
        modules: [Autoplay, Pagination, Navigation, Thumbs, Controller],
        spaceBetween: 4,
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: false,
        autoplay: {
            delay: 30000,
            pauseOnMouseEnter: true,
        },
        thumbs: {
            swiper: thumbs,
        },
        breakpoints: {
            0: {
                slidesPerView: 'auto',
            },
            1440: {
                slidesPerView: 1,
            },
        },
        controller: { control: null },
    });
    const mainSlideBadges = document.querySelector('.product-info-main-slider .product-info-badges');
    function onSlideChange(slider) {
        if (mainSlideBadges) {
            if (slider.activeIndex !== 0) {
                mainSlideBadges.style.display = 'none';
            }
            else {
                mainSlideBadges.style.display = 'flex';
            }
        }
    }
    swiper.on('slideChange', onSlideChange);
    (_a = document.querySelector(`.product-info-slider .swiper-button-next`)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
        if (swiper.activeIndex === swiper.slides.length - 1) {
            swiper.slideTo(0);
        }
        else {
            swiper.slideNext();
        }
    });
    return swiper;
}
const Sliders = {
    initSwiper,
    initSwiperHeroBanner,
    initMarqueeLineSwiper,
    initOftenChooseSwiper,
    initInstagramReviewSwiper,
    initCrossSellsSwiper,
    initCartPromoSwiper,
    initCatalogueBanner,
    initCheckoutSlider,
    initProductSlider,
    initProductSliderThumb,
    initCertificatesSwiper,
    initFsSlider,
};
export default Sliders;
